import React from 'react';
import cls from '@utils/css-select'
import styles from './styles.scss'

const cx = cls(styles)

function ModuleTitle (props: { children: React.ReactNode }) {
	return <h2 className={cx('module-title-container')}>
		{props.children}
	</h2>
}

export default ModuleTitle
